<template>
    <div id="app">
      <div id="nav">
        <a href="javascript:;" class="logo"><img src="../assets/logo.png" alt="无端科技"></a>
        <div v-for="(menu,index) in menus" :key="'nav-'+index" class="menu-container" :class="'menu-'+index">
          <b @click="setActiveMenu(index)" :class="activeMenu == index?'active':''">{{menu.title}}</b>
          <router-link :class="{active:activeMenu == index && activeSubMenu == idx}" v-show="activeMenu == index" :to="{path:subMenu.name,query: {from}}" v-for="(subMenu,idx) in menu.subMenus" :key="'sub-menu-'+idx">{{subMenu.title}}</router-link>
        </div>
      </div>
      <div id="main">
        <div id="header">
          <ul>
            <li v-if="displayAccount" class="header-account">
              <b>{{displayAccount}}</b> | <a href="javascript:;" @click="logout">{{$t("header.Logout")}}</a>
            </li>
            <li class="header-games subs">
              <b>{{$t("header.GameLists")}}</b>
              <div class="sub-content games-content">
                <a :href="game.link[$i18n.locale] || game.link.default" v-for="(game,idx) in games" :key="'app-game-'+idx">{{game.name[$i18n.locale]}}</a>
              </div>
            </li>
            <li class="header-link">
              <router-link :to="{path: '/user', query: {from}}">{{$t('header.UserCenter')}}</router-link> 
            </li>
            <li class="header-link">
              <router-link :to="{path: '/password', query: {from}}">{{$t('header.SecurityCenter')}}</router-link> 
            </li>
            <li class="header-link">
              <router-link :to="{path: '/recharge', query: {from}}">{{$t('header.VoucherCenter')}}</router-link>
            </li>
            <li class="header-link">
              <a :href="'http://www.wooduan.com/service?lang='+($i18n.locale=='zh'?'zh':'en')" target="_blank">{{$t('header.CustomerServiceCenter')}}</a> 
            </li>
            <li class="header-lans subs">
              <b>{{$t('header.Language')}}</b>
              <div class="sub-content lans-content">
                <a href="javascript:;" @click="setLanguage(lan.key)" v-for="(lan,idx) in base_configs.languages" :key="idx">{{lan.name}}</a>
              </div>
            </li>
          </ul>
        </div>
        <div id="breadcrumb">
          <span>{{$t("header.CurrentPosition")}} <i>:</i> <router-link :to="{path:menus[activeMenu].subMenus[0].name,query: {from}}">{{menus[activeMenu].title}}</router-link> <i>/</i> {{menus[activeMenu].subMenus[activeSubMenu].title}}</span>
        </div>
        <div id="container">
          <div v-if="showResult" class="result-div">
            <h3><span>操作成功</span></h3>
            <p>
              <img src="../assets/success.png" height="30" alt="">
              <b>{{resultMsg}}</b>
            </p>
            <wd-button type="danger" @click.native="showResult = false" size="large" :styles="{width:'300px'}">返回({{resultTime}})</wd-button>
          </div>
          <router-view v-show="!showResult"/>
        </div>
      </div>
    </div>
</template>
<script>
let timeInterval = null;
import WdButton from '@/components/WdButton.vue';

export default {
    name:'home',
    data() {
        return {
            activeMenu:0,
            activeSubMenu:0,
            account:"",
            email:"",
            phone:"",
            nick:"",
            games:[],
            isLoading:true,
            showResult:false,
            resultMsg:"",
            resultTime:5,
            base_configs:{},
            games:[],
            from: '',
        }
    },
    components:{
			'wd-button':WdButton
		},
    async created(){
        this.from = this.$route.query.from || '';
        console.log('home', this.from)
        let {base_configs,games} = await this.$getAppBaseData(this.from);
        this.base_configs = base_configs;
        this.games = games;
        let user = await this.$getUser();

        if(user){
            this.user = user;
            this.account = user.account;
            this.email = user.email;
            this.phone = user.phone;
            this.nick = user.nick;
        }

        this.$events.listen('RESULT-SHOW',this.showResultPage);
        this.$events.listen('USER-INFO',(user)=>{
          if(!user){
            // this.$router.push('/');
            this.$router.replace({name: 'login',query: {from: this.from}});
          }
        })
        this.$router.afterEach((to, from) => { 
            this.hideResult();
            this.menus.map((elem,index) => {
                this.menus[index].subMenus.map((menu,idx) => {
                if(this.menus[index].subMenus[idx].router == to.path){
                    this.activeMenu = index;
                    this.activeSubMenu = idx;
                }
                })
            })
        })

        let path = this.$route.path;
        this.menus.map((elem,index) => {
          this.menus[index].subMenus.map((menu,idx) => {
            if(this.menus[index].subMenus[idx].router == path){
                this.activeMenu = index;
                this.activeSubMenu = idx;
            }
          })
        })
    },
    computed:{
        menus(){
        let menus = [
            {
            title:this.$t("nav.UserCenter"),
            subMenus:[
                {title:this.$t("nav.MyAccount"),router:'/user',name: 'user', query: this.from},
                {title:this.$t("nav.ThirdAccount"),router:'/third',name: 'third',query: this.from}
            ]
            },
            {
            title:this.$t("nav.SecurityCenter"),
            subMenus:[
                {title:this.$t("nav.ChangePassword"),router:'/password',name: 'password',query: this.from},
                {title:this.$t("nav.Email"),router:'/email',name: 'email',query: this.from},
                {title:this.$t("nav.SecurityQuestion"),router:'/securityQuestion',name: 'securityQuestion',query: this.from},
                {title:this.$t("nav.AccountComplaint"),router:'/AccountComplaint',name: 'AccountComplaint',query: this.from},
            ]
            },
            {
            title:this.$t("nav.VoucherCenter"),
            subMenus:[
                {title:this.$t("nav.RechargeHistory"),router:'/recahrgeHistory',name: 'recahrgeHistory',query: this.from}
            ]
            }
        ];
        if(this.base_configs.used_recharge){
            menus[2].subMenus.splice(0,0,{title:this.$t("nav.GameRecharge"),router:'/recharge',name: 'recharge',query: this.from});
        }
        if(this.base_configs.used_phone_reg){
            menus[1].subMenus.splice(1,0,{title:this.$t("nav.Phone"),router:'/phone',name: 'phone',query: this.from});
        }
        if(this.base_configs.used_realname){
            menus[1].subMenus.splice(1,0,{title:this.$t("nav.RealNameAuthentication"),router:'/authentication',name: 'authentication',query: this.from},);
        }

        return menus;
        },

        displayAccount(){
            if(this.account) return this.account;
            if(this.nick) return this.nick;
            if(this.phone) return this.phone;
            if(this.email) return this.email;
            return this.account;
        }
    },
    methods:{
        setActiveMenu(idx,activeSubMenu){
            if(idx == this.activeMenu) return;
            if(!activeSubMenu) activeSubMenu = 0;
            this.$router.push({name: this.menus[idx].subMenus[activeSubMenu].name, query: {from: this.from}});
        },
        setLanguage(lan){
            this.$i18n.locale = lan
            localStorage.setItem('WIZARD_MEMBER_LANGUAGE',lan);
        },
        logout(){
            this.$api.setAuthToken('');
            this.$setUser(null);
        },
        hideResult(){
            this.showResult = false;
            clearInterval(timeInterval);
            timeInterval = null;
        },
        showResultPage(msg){
            this.showResult = true;
            this.resultTime = 5;
            this.resultMsg = msg;
            timeInterval = setInterval(()=>{
                if(this.resultTime<2){
                this.hideResult();
                return;
                }
                this.resultTime -=1;
            },1000);
        }
    }
}
</script>